/*
	import { addAmenityReservation } from '@/services/Amenities/AmenityReservation/Post';

  const { successful, message } = await addAmenityReservation ({
    json: {
      amenityID: 14,
      reservationOwnerID: 3045,
			//
			startDate:
			endDate:
			//
      reservationIdentityID: '_',
      //
      notes: "notes about the reservation",
      amenityReservation: "?"
    }
  });
  if (!successful) {
    console.error (message);
    return;
  }
*/

import kms from '@/services/kms'

export async function addAmenityReservation({ json }) {
  let message = 'The amenity could not be reserved.'

  try {
    const result = await kms.post(`/Amenities/AmenityReservation`, json)

    return {
      successful: true,
      message,
      result
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    result: null
  }
}
